const accountNavLogoWrap = document.querySelector('.account-navigation-logo-wrap');
const accountMenuButtonMobile = document.querySelector('.js--account-button-mobile');

if (accountMenuButtonMobile) {
  accountMenuButtonMobile.addEventListener("click", () => {
    accountMenuButtonMobile.parentElement.classList.toggle("is-active")
  });
}

window.addEventListener('click', function(e){
  if (accountNavLogoWrap && !accountNavLogoWrap.contains(e.target)){
    accountMenuButtonMobile.parentElement.classList.remove("is-active")
  }
});